<template>
  <b-card>
    <b-card-title> 室内环境</b-card-title>
    <div style="height: 810px; display: flex; flex-direction: column">
      <div style="min-height: 38rem">
        <b-row>
          <b-col cols="12" class="custom_padding">
            <h6 style="font-size: 0.9rem">运行目标选择</h6>
          </b-col>
          <b-col cols="12" class="mb-1 custom_padding">
            <b-form-radio-group v-model="form.target">
              <b-form-radio value="0"> 日运行能耗最低 </b-form-radio>
              <b-form-radio value="1"> 日运碳排放最低</b-form-radio>
            </b-form-radio-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" class="custom_padding">
            <h6 style="font-size: 0.9rem">运行模式选择:</h6>
          </b-col>
          <b-col cols="12" class="mb-1 custom_padding">
            <b-form-radio-group v-model="form.mode">
              <b-form-radio value="0">时间表 </b-form-radio>
              <b-form-radio value="1">算法模式</b-form-radio>
            </b-form-radio-group>
          </b-col>
          <b-row v-if="form.mode == '0'">
            <b-col cols="12" class="mb-1 custom_padding d-flex align-items-center">
              <div class="custom_label_select">
                <label>开机时间:</label>
              </div>
              <div style="padding-right: 3rem">
                <el-time-picker v-model="form.startTime" prefix-icon="none" format="HH:mm" value-format="HH:mm"> </el-time-picker>
              </div>
            </b-col>
            <b-col cols="12" class="mb-1 custom_padding d-flex align-items-center">
              <div class="custom_label_select">
                <label>关机时间:</label>
              </div>
              <div style="padding-right: 3rem">
                <el-time-picker v-model="form.endTime" prefix-icon="none" format="HH:mm" value-format="HH:mm"> </el-time-picker>
              </div>
            </b-col>
          </b-row>
          <b-row v-else>
            <b-col cols="12" class="mb-1 ml-2 custom_padding">
              <b-form-radio-group v-model="form.algorithm">
                <b-form-radio value="0"> 粒子群算法 </b-form-radio>
                <b-form-radio value="1"> 遗传算法</b-form-radio>
              </b-form-radio-group>
            </b-col>
          </b-row>
        </b-row>
        <b-row>
          <b-col cols="12" class="custom_padding">
            <h6 style="font-size: 0.9rem">参数设定</h6>
          </b-col>
          <b-col cols="12" class="mb-1 custom_padding d-flex align-items-center">
            <div class="custom_label">
              <label>最不利压差设定:</label>
            </div>
            <div>
              <b-form-input v-model="form.zblycsd" type="number"></b-form-input>
            </div>
          </b-col>
          <b-col cols="12" class="mb-1 custom_padding d-flex align-items-center">
            <div class="custom_label">
              <label>冷机最大可开启台数:</label>
            </div>
            <div>
              <b-form-input v-model="form.ljzdkkqs" type="number"></b-form-input>
            </div>
          </b-col>
          <b-col cols="12" class="mb-1 custom_padding d-flex align-items-center">
            <div class="custom_label">
              <label>冷冻水供水温度设定（℃）:</label>
            </div>
            <div>
              <b-form-input v-model="form.ldsgswdsd" type="number"></b-form-input>
            </div>
          </b-col>
          <b-col cols="12" class="mb-1 custom_padding d-flex align-items-center">
            <div class="custom_label">
              <label>冷冻水供回水温差（℃）:</label>
            </div>
            <div>
              <b-form-input v-model="form.ldsgshswc" type="number"></b-form-input>
            </div>
          </b-col>
          <b-col cols="12" class="mb-1 custom_padding d-flex align-items-center">
            <div class="custom_label">
              <label>冷却水供水温度设定（℃）:</label>
            </div>
            <div>
              <b-form-input v-model="form.lqsgswdsd" type="number"></b-form-input>
            </div>
          </b-col>
          <b-col cols="12" class="custom_padding d-flex align-items-center">
            <div class="custom_label">
              <label>冷却供回水温差设定（℃）:</label>
            </div>
            <div>
              <b-form-input v-model="form.lqghswcsd" type="number"></b-form-input>
            </div>
          </b-col>
        </b-row>
        <div class="d-flex justify-content-end mt-1" style="gap: 1rem">
          <b-btn size="sm" variant="outline-primary" @click="reset">重置</b-btn>
          <b-btn size="sm" variant="primary" @click="submit">设定</b-btn>
        </div>
      </div>
      <hr class="mb-2.5 offsetMargin" />
      <b-card-sub-title>当日节能和降碳量</b-card-sub-title>
      <div id="project-detail-energy-column1" style="flex: 1"></div>
    </div>
  </b-card>
</template>

<script>
import { Area, Column } from '@antv/g2plot';
import { $themeColors } from '@themeConfig';
import { computed, onMounted, reactive, toRefs, watch, ref } from '@vue/composition-api';
import { routerParams } from '@/libs/utils/routerParams';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import { setParams } from '@/api/diagnosis';
import { showToast } from '@/libs/utils/showToast';

export default {
  name: 'Environment',
  props: {
    project_params: [Object],
    project_info: [Object],
    project_energy: [Object],
  },
  components: {
    VuePerfectScrollbar,
  },
  setup(props) {
    const event = reactive({
      projectEnergy: computed(() => {
        return props.project_energy;
      }),
      co2: {
        today: 0,
        last: 0,
      },
      projectParams: computed(() => {
        return (
          props.project_params || {
            list: {},
            current: {},
          }
        );
      }),
      projectInfo: computed(() => {
        return props.project_info || { city: null, lng: null, lat: null };
      }),
      project_id: computed(() => {
        return 7;
      }),
      chartNames: computed(() => {
        let keys = [
          { key: 'OUTTEMP', title: '温度', unit: '℃' },
          { key: 'OUTHUMI', title: '湿度', unit: '%' },
          { key: 'OUTFZD', title: '辐照', unit: 'W/m<sub>2</sub>' },
          {
            key: 'OUTPM2.5',
            title: 'PM2.5',
            unit: 'μg/m<sup>3</sup>',
          },
        ];
        if (parseInt(event.project_id) === 7) {
          keys = [
            { key: 'R315RT', title: '温度', unit: '℃' },
            { key: 'R315RH', title: '湿度', unit: '%' },
            { key: 'R315CO2', title: 'CO2', unit: 'ppm' },
            {
              key: 'Room319_PM2.5',
              title: 'PM2.5',
              unit: 'μg/m<sup>3</sup>',
            },
          ];
        }
        return keys;
      }),
      charts: {},
      latestParams: {},
      tableColumns: [
        {
          label: '节能运行参数',
          key: 'param_name',
        },
        {
          label: '当前值',
          key: 'cur_value',
        },
        {
          label: '推荐值',
          key: 'rec_value',
        },
        {
          label: '变化',
          key: 'change',
        },
      ],
      strategySummer: [
        {
          param_name: '冷冻水出水温度 (℃)',
          cur_value: '7.2',
          rec_value: '8',
          change: '',
        },
        {
          param_name: '制冷机开启台数',
          cur_value: '1',
          rec_value: '1',
          change: '',
        },
        {
          param_name: '冷冻水泵频率 (Hz)',
          cur_value: '45',
          rec_value: '42',
          change: '',
        },
        {
          param_name: '冷却水泵频率 (Hz)',
          cur_value: '47',
          rec_value: '42',
          change: '',
        },
        {
          param_name: '冷却塔开启台数',
          cur_value: '1',
          rec_value: '1',
          change: '',
        },
        {
          param_name: '冷却塔风机频率 (Hz)',
          cur_value: '35',
          rec_value: '30',
          change: '',
        },
        {
          param_name: '开机时间',
          cur_value: '8:00',
          rec_value: '8:30',
          change: '',
        },
        {
          param_name: '关机时间',
          cur_value: '18:00',
          rec_value: '17:30',
          change: '',
        },
      ],
      strategyWinter: [
        {
          param_name: '冷凝侧出水温度 (℃)',
          cur_value: '45',
          rec_value: '42',
          change: '',
        },
        {
          param_name: '冷凝侧回水温度 (℃)',
          cur_value: '40',
          rec_value: '38',
          change: '',
        },
        {
          param_name: '蒸发侧出水温度 (℃)',
          cur_value: '10',
          rec_value: '9',
          change: '',
        },
        {
          param_name: '蒸发侧回水温度 (℃)',
          cur_value: '12',
          rec_value: '13',
          change: '',
        },
        {
          param_name: '冷却水泵频率 (Hz)',
          cur_value: '45',
          rec_value: '43.5',
          change: '',
        },
        {
          param_name: '室内侧水泵频率 (Hz)',
          cur_value: '50',
          rec_value: '48',
          change: '',
        },
        {
          param_name: '冷机开启台数',
          cur_value: '2',
          rec_value: '2',
          change: '',
        },
        {
          param_name: '开机时间',
          cur_value: '8:00',
          rec_value: '7:50',
          change: '',
        },
        {
          param_name: '关机时间',
          cur_value: '18:00',
          rec_value: '17:30',
          change: '',
        },
      ],
    });
    const form = ref({
      target: '0',
      mode: '0',
      startTime: '',
      endTime: '',
      algorithm: '0',
      zblycsd: '',
      ljzdkkqs: '',
      ldsgswdsd: '',
      ldsgshswc: '',
      lqsgswdsd: '',
      lqghswcsd: '',
    });
    watch(
      () => event.projectParams,
      (projectParams) => {
        console.log('数据发送变化projectParams', projectParams);
        const timeList = [
          '00:00',
          '01:00',
          '02:00',
          '03:00',
          '04:00',
          '05:00',
          '06:00',
          '07:00',
          '08:00',
          '09:00',
          '10:00',
          '11:00',
          '12:00',
          '13:00',
          '14:00',
          '15:00',
          '16:00',
          '17:00',
          '18:00',
          '19:00',
          '20:00',
          '21:00',
          '22:00',
          '23:00',
        ];
        let latestParams = {};

        event.chartNames.map((name) => {
          try {
            const key = name.key;
            let exist_hours = [];
            let projectParamsItem = Object.assign([], Object.values(projectParams.list[key]));
            projectParamsItem.map((item) => {
              exist_hours.push(item.time);
              if (item.value) {
                latestParams[key] = item.value;
              }
            });
            timeList.map((hour) => {
              if (!exist_hours.includes(hour)) {
                projectParamsItem.push({
                  name: key,
                  value: null,
                  time: hour,
                });
              }
            });
            event.charts[key].changeData(projectParamsItem);
          } catch (error) {}
        });
        event.latestParams = latestParams;
      }
    );
    watch(
      () => event.projectEnergy,
      (projectEnergy) => {
        event.co2.today = Math.round(parseFloat(projectEnergy.day.value) * event.co2_coefficient * 100) / 100;
        event.co2.last = Math.round(parseFloat(projectEnergy.day.last) * event.co2_coefficient * 100) / 100;
        const energy_list = projectEnergy.year.list;
        let energy_month_list_eneryg = {};
        let energy_month_list_carbon = {};
        energy_list.map((energyItem) => {
          energyItem['time'] = energyItem['time'].replace('-01 00:00:00', '');
          if (!energy_month_list_eneryg[energyItem.time]) {
            energy_month_list_eneryg[energyItem.time] = {
              name: 'energy',
              time: '',
              value: 0,
            };
          }
          energy_month_list_eneryg[energyItem.time]['time'] = energyItem.time;
          energy_month_list_eneryg[energyItem.time]['value'] += parseInt(energyItem.value);
        });
        energy_list.map((energyItem) => {
          energyItem['time'] = energyItem['time'].replace('-01 00:00:00', '');
          if (!energy_month_list_carbon[energyItem.time]) {
            energy_month_list_carbon[energyItem.time] = {
              name: 'carbon',
              time: '',
              value: 0,
            };
          }
          energy_month_list_carbon[energyItem.time]['time'] = energyItem.time;
          energy_month_list_carbon[energyItem.time]['value'] += parseInt(energyItem.c_value);
        });
        const energy_month_list = Object.values(energy_month_list_eneryg).concat(Object.values(energy_month_list_carbon));
        event.columnPlot.changeData(energy_month_list);
      }
    );
    const columnChartInit = () => {
      const columnPlot = new Column('project-detail-energy-column1', {
        data: [],
        isGroup: true,
        seriesField: 'name',
        xField: 'time',
        yField: 'value',
        xAxis: {
          label: {
            autoHide: true,
            autoRotate: false,
          },
          line: null,
          grid: null,
          tickLine: null,
        },
        yAxis: {
          line: null,
          grid: null,
          label: null,
        },
        columnStyle: {
          radius: [5, 5, 5, 5],
        },
        meta: {
          time: {
            alias: '月份',
          },
          value: {
            alias: '耗电量',
          },
        },
      });
      columnPlot.render();
      event.columnPlot = columnPlot;
    };
    const reset = () => {
      form.value = {
        target: '0',
        mode: '0',
        startTime: '',
        endTime: '',
        algorithm: '0',
        zblycsd: '',
        ljzdkkqs: '',
        ldsgswdsd: '',
        ldsgshswc: '',
        lqsgswdsd: '',
        lqghswcsd: '',
      };
    };
    const submit = () => {
      const list = [];
      Object.entries(form.value).forEach(([field, value]) => {
        list.push({ field, value });
      });
      setParams(list).then((res) => {
        if (res.data.code === 200) {
          showToast('', '成功', '参数下发成功');
        }
      });
    };

    onMounted(() => {
      columnChartInit();
    });
    return {
      ...toRefs(event),
      form,
      reset,
      submit,
    };
  },
};
</script>

<style lang="scss" scoped>
.custom_padding {
  padding-right: 0.5rem;
  padding-left: 0.5rem;
  ::v-deep .bv-no-focus-ring {
    display: flex;
    justify-content: start;
    .custom-radio {
      display: flex;
      align-items: center;
      padding-left: 1.5rem;
      margin-right: 1rem;
      &:last-child {
        margin-right: 0;
      }
      .custom-control-label {
        font-size: 0.857rem;
        &::before {
          width: 16px;
          height: 16px;
        }
      }
    }
  }
}
.custom_label_select {
  width: 6rem;
  text-align: end;
  margin-right: 0.5rem;
  margin-left: 1.5rem;
}
.custom_label {
  width: 25rem;
  text-align: end;
  margin-right: 0.5rem;
}
.offsetMargin {
  margin-left: -1.5rem;
  margin-right: -1.5rem;
  margin-bottom: 2rem;
}

.el-date-editor {
  max-width: 10rem;
  width: 100%;
  ::v-deep .el-input__inner {
    height: 2.2rem;
  }
  .dark-layout & {
    ::v-deep .el-input__inner {
      border-color: #404656;
      background-color: #283046;
      color: #b8c2cc;
    }
  }
  ::v-deep .el-input__icon {
    line-height: 2.2rem;
  }
}
.form-control {
  height: 2.2rem;
}
</style>
<style lang="scss">
.el-time-panel {
  .dark-layout & {
    background-color: #293047;
    border: 1px solid #404656;
    .el-time-panel__content {
      &:before,
      &:after {
        border-top: 1px solid #404656;
        border-bottom: 1px solid #404656;
      }
      .el-time-spinner__item:hover {
        background: #030406;
      }
      .el-time-spinner__item.active {
        color: #c7daff;
      }
    }
    .el-time-panel__footer {
      border-top: 1px solid #404656;
      .cancel {
        color: #dfeaff;
      }
    }
  }
}
</style>
